import { useState } from "react";
import { useTranslation } from "react-i18next";
import DemoModal from "./DemoModal";
import RegisterModal from "./RegisterModal";

export default function CTASection() {
  const { t } = useTranslation();
  const [showDemo, setShowDemo] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  return (
    <>
      {showDemo && <DemoModal onClose={() => setShowDemo(false)} />}
      {showRegister && (
        <RegisterModal
          onClose={() => setShowRegister(false)}
          onOpenDemo={() => setShowDemo(true)}
        />
      )}

      <section
        className="relative py-40 flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `url(https://public.readdy.ai/ai/img_res/22be6aa5b10e7455b44fe1cbac36d501.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-stone-900/75 via-stone-900/65 to-stone-900/80" />

        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-amber-400/40 bg-amber-400/10 backdrop-blur-sm mb-8">
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
            <span className="text-amber-300 text-xs font-semibold tracking-widest uppercase">
              {t("cta_badge")}
            </span>
          </span>

          <h2
            className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {t("cta_title_1")}
            <br />
            <span className="text-amber-400">{t("cta_title_2")}</span>
          </h2>

          <p className="text-white/70 text-xl max-w-2xl mx-auto leading-relaxed mb-10">
            {t("cta_subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <button
              onClick={() => setShowRegister(true)}
              className="flex items-center gap-2.5 px-10 py-4 bg-amber-500 hover:bg-amber-400 text-white font-bold rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
            >
              <i className="ri-user-add-line text-xl" />
              {t("cta_btn_register")}
            </button>
            <button
              onClick={() => setShowDemo(true)}
              className="flex items-center gap-2.5 px-10 py-4 border-2 border-white/30 hover:border-white/60 text-white font-semibold rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-base backdrop-blur-sm"
            >
              <i className="ri-play-circle-line text-xl" />
              {t("cta_btn_demo")}
            </button>
          </div>

          <p className="text-white/40 text-sm">{t("cta_disclaimer")}</p>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-8">
            {[
              { icon: "ri-lock-line", key: "cta_trust_1" },
              { icon: "ri-time-line", key: "cta_trust_2" },
              { icon: "ri-customer-service-line", key: "cta_trust_3" },
            ].map((item) => (
              <div key={item.key} className="flex items-center gap-2">
                <i className={`${item.icon} text-amber-400 text-lg`} />
                <span className="text-white/60 text-sm">{t(item.key)}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
